import { render, staticRenderFns } from "./DocumentoSignatarioNovo.vue?vue&type=template&id=45023bf8"
import script from "./DocumentoSignatarioNovo.vue?vue&type=script&lang=js"
export * from "./DocumentoSignatarioNovo.vue?vue&type=script&lang=js"
import style0 from "./DocumentoSignatarioNovo.vue?vue&type=style&index=0&id=45023bf8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports